// The languages the platform's own interface can be shown in: menus, buttons,
// messages. A survey's languages are a different list (`Languages/getAll`) and
// are the author's to choose; this one is the reader's.
//
// `name` is written in the language itself, so a person who cannot read the
// current interface can still find their own.
export const LANGUAGES = Object.freeze([
   { code: "en", name: "English", dir: "ltr" },
   { code: "ar", name: "العربية", dir: "rtl" },
   { code: "fr", name: "Français", dir: "ltr" },
   { code: "es", name: "Español", dir: "ltr" }
]);

export const DEFAULT_LANGUAGE = "en";

export const findLanguage = (code) =>
   LANGUAGES.find((language) => language.code === code) ||
   LANGUAGES.find((language) => language.code === DEFAULT_LANGUAGE);

// TEMPORARY - production only shows English until the Arabic, French and Spanish
// translations are confirmed. Remove this flag (and the places that read it) once they are.
//
// Production is told apart by its API, because the staging deploy builds with
// .env.production too (only the URLs are overridden), so an .env flag would hide
// the picker on staging as well.
export const LANGUAGE_CHOICE_ENABLED = !String(process.env.REACT_APP_BASE_URL || "").includes(
   "prodapi.kapsurvey.com"
);
